<template>
  <button
    type="button"
    class="btn btn-success c-rounded-pill border-0"
    :class="addClass"
    :aria-expanded="ariaExpanded || undefined"
    :aria-controls="ariaControls"
    :aria-labelledby="ariaLabelledby"
    :aria-label="ariaLabelledby"
  >
    <template
      v-if="!plusOnly"
    >
      <i
        class="mi-plus"
        :class="[`icon-${iconSize}px`, { 'block c-xl:hidden' : !iconNoHide }]"
      />
      <span class="hidden c-xl:block c-p-0">{{ t('add_portion') }}</span>
    </template>
    <i
      v-else
      class="mi-plus"
      :class="`icon-${iconSize}px`"
    />
    <span
      v-if="counter > 0"
      class="inline-block c-p-2 absolute top-0 right-0 mr-n1 bg-warning c-rounded-circle"
    >
      <span
          class="absolute centered text-sm-c text-white c-leading-1"
          data-cy="cart-item-counter"
      >{{ counter }}</span>
    </span>
  </button>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineProps({
  plusOnly: {
    type: Boolean,
    default: true,
  },

  addClass: {
    type: String,
    default: '',
  },

  counter: {
    type: Number,
    default: 0,
  },

  iconSize: {
    type: String,
    default: '16',
  },

  ariaExpanded: {
    type: Boolean,
  },

  ariaControls: {
    type: String,
    default: '',
  },

  ariaLabelledby: {
    type: String,
    default: 'Plus button',
  },

  iconNoHide: {
    type: Boolean,
    default: false,
  },
})
const { t } = useI18n()
</script>

<i18n>
  {
    "cs": {
    "add_portion": "Přidat porci"
},
    "sk": {
    "add_portion": "Pridať porciu"
},
    "pl": {
    "add_portion": "Dodaj porcję"
},
    "hu": {
    "add_portion": "Hozzaadni"
},
    "de": {
    "add_portion": "Hinzufügen"
},
    "at": {
    "add_portion": "Hinzufügen"
},
    "ro": {
    "add_portion": "Adaugă o porție"
},
    "fr": {
    "add_portion": "Ajouter"
},
    "it": {
    "add_portion": "Aggiungi"
}
  }
</i18n>
